import { isNullable } from '@ipfabric/utils';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { getContainerDimensions } from 'components/DeviceView/helpers/getContainerDimensions';
import { getWindowGreatestZIndex } from 'components/DeviceView/helpers/getWindowGreatestZIndex';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface MaximizeWindowCommand {
  deviceViewEntityId: DeviceViewEntityId;
}

export const maximizeWindow: DeviceViewCommandFactory<MaximizeWindowCommand> =
  (cmdContext) => (command) => {
    if (isNullable(cmdContext.getState().deviceViewContainer)) {
      return;
    }

    cmdContext.updateState((draft) => {
      const foundWindow = draft.deviceViewWindows.find(
        (win) => win.id === command.deviceViewEntityId,
      );
      if (foundWindow === undefined) {
        return;
      }
      if (!foundWindow.maximize) {
        const currentZIndex = foundWindow.zIndex;
        const greatestZIndex = getWindowGreatestZIndex(draft.deviceViewWindows);
        if (currentZIndex !== greatestZIndex) {
          foundWindow.zIndex = greatestZIndex;
        }
        foundWindow.beforeMaximizeX = foundWindow.x;
        foundWindow.beforeMaximizeY = foundWindow.y;
        foundWindow.x = 0;
        foundWindow.y = 0;
        foundWindow.maximize = true;
        const { height, width } = getContainerDimensions(
          cmdContext.getState().deviceViewContainer,
        );
        foundWindow.beforeMaximizeWidth = foundWindow.width;
        foundWindow.beforeMaximizeHeight = foundWindow.height;
        foundWindow.height = height;
        foundWindow.width = width;
      } else {
        foundWindow.x = foundWindow.beforeMaximizeX;
        foundWindow.y = foundWindow.beforeMaximizeY;
        foundWindow.height = foundWindow.beforeMaximizeHeight;
        foundWindow.width = foundWindow.beforeMaximizeWidth;
        foundWindow.maximize = false;
      }
    });
  };
